import { debounce } from 'helpers/helpers'

const arSearchPopup = {
  init(): void {
    document.querySelectorAll<HTMLElement>('.ar-search-popup').forEach((target: HTMLElement) => {
      this.handleSearchPopup(target)
    })
  },

  handleSearchPopup(target: HTMLElement): void {
    const el = {
      searchSuggestionsContainer: target.querySelector<HTMLDivElement>('.ar-search-popup__results-container'),
      searchForm: target.querySelector<HTMLFormElement>('.ar-search-form'),
      searchPageForm: target.querySelector<HTMLFormElement>('.ar-search-popup__search-page-form'),
      searchPageQuery: target.querySelector<HTMLInputElement>('#search-page-query'),
      searchInput: target.querySelector<HTMLInputElement>('.input-group--search-ar input'),
    }

    const { searchSuggestionsContainer, searchPageQuery, searchInput, searchForm } = el
    if (searchForm) {
      searchForm.onsubmit = (e) => this.handleSubmit(e, el)

      if (searchInput && searchPageQuery) {
        searchInput.addEventListener('keyup', () => {
          searchPageQuery.value = searchInput.value
          // console.log(searchInput.value, searchSuggestionsContainer)
          if (searchSuggestionsContainer && searchInput.value.length <= 0) {
            debounce(searchSuggestionsContainer.classList.add('hide'), 300)
          }
        })
      }

      // handle clickoutside
      if (searchSuggestionsContainer) {
        document.addEventListener('click', (e) => {
          const target = e.target as HTMLElement
          if (!target.classList.contains('ar-search__suggestion') && !target.classList.contains('input-group__input')) {
            searchSuggestionsContainer.classList.add('hide')
          }
        })
      }
    }
  },

  handleSubmit(e, el) {
    e.preventDefault()
    e.stopPropagation()
    if (el.searchPageForm) {
      el.searchPageForm.submit()
    }
  },
}

export default arSearchPopup
